import type { CodeReviewerSetting } from '../../types';
import { parseCodeReviewerSettingValue } from '../../utils';

import { CodeReviewerSettingToggle } from './code-reviewer-setting-toggle';

type RepositoryToggleProps = {
	repository: GH.Repository;
	orgSetting: CodeReviewerSetting | null;
	superToggle?: (repoId: string, newValue: boolean) => void;
};
export const RepositoryToggle = ({
	repository,
	orgSetting,
	superToggle,
}: RepositoryToggleProps) => {
	const isEnabledForOrg: boolean = orgSetting?.value
		? parseCodeReviewerSettingValue(orgSetting?.value)
		: false;

	const onToggle: ((newValue: boolean) => void) | undefined = superToggle
		? (newValue: boolean) => {
				superToggle(repository.repoId, newValue);
			}
		: undefined;

	const setting = repository.autoreviewSettings
		? parseCodeReviewerSettingValue(repository.autoreviewSettings?.value)
		: false;

	return (
		<CodeReviewerSettingToggle
			type="repository"
			entityUrl={repository.repoUrl}
			setting={setting}
			disableToggle={!isEnabledForOrg}
			onToggle={onToggle}
		/>
	);
};
